export const SetLocalStorage = (item, value) => {
  localStorage.setItem(item, JSON.stringify(value));
};
